<app-video *ngIf="dataUrl" [url]="dataUrl" [videoId]="mediaId" [(currentCueId)]="cueId" (currentCueIdChange)="cueIdUpdated($event)"></app-video>
<div class="loading" *ngIf="!dataUrl">
  <img src="../../../assets/logos/oc_spiral.svg" alt="loading" />
</div>
